import { useMe } from './useMe';
export function useConsolidatorCurrency() {
    var _a;
    var data = useMe().data;
    var currency = (_a = data === null || data === void 0 ? void 0 : data.currency) !== null && _a !== void 0 ? _a : '';
    return { currency: currency };
}
